import Typography from '@components/v2/ui/Typography/Typography';
import classNames from 'classnames';
import { MoneyRendererV3DirectionEnum, MoneyRendererV3Props } from './moneyRendererV3.types';
import useMoneyRendererV3 from './useMoneyRendererV3';
import { useMoneyRendererV3Styles } from './useMoneyRendererV3.styles';

const MoneyRendererV3 = ({
  color,
  promotionTextColor,
  promotionValue,
  value,
  direction = MoneyRendererV3DirectionEnum.COLUMN,
  horizontalAlign = 'left',
  size = 'small',
  useSign = false,
  originalPriceTestId,
  discountedPriceTestId,
  valueTestId,
  integerValueTestId,
  centsValueTestId,
}: MoneyRendererV3Props) => {
  const { hasPromotion, promotionConfig, valueConfig } = useMoneyRendererV3({
    promotionValue,
    value,
    useSign,
  });
  const { classes } = useMoneyRendererV3Styles({
    promotionTextColor,
    size,
  });

  const promotionContent = hasPromotion && (
    <Typography
      variant="body2"
      className={classNames(classes.promotionStyle)}
      align={horizontalAlign === 'right' ? 'right' : 'left'}
      testId={originalPriceTestId}
    >
      {valueConfig.real}
      <span className={classes.cents}>{valueConfig.cents}</span>
    </Typography>
  );

  const price = {
    real: hasPromotion ? promotionConfig.real : valueConfig.real,
    cents: hasPromotion ? promotionConfig.cents : valueConfig.cents,
  };

  return (
    <div
      style={{
        whiteSpace: 'nowrap',
        display: 'flex',
        flexDirection: direction,
        columnGap: '8px',
        rowGap: '2px',
        justifyContent: horizontalAlign === 'left' ? 'flex-start' : 'flex-end',
      }}
    >
      {direction === MoneyRendererV3DirectionEnum.COLUMN && promotionContent}

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: horizontalAlign === 'left' ? 'flex-start' : 'flex-end',
        }}
        {...{ 'test-id': valueTestId ?? discountedPriceTestId }}
      >
        <Typography variant="body2" color={color} className={classes.principalPriceStyle}>
          <span {...{ 'test-id': integerValueTestId }}>{price.real}</span>
          <span className={classes.cents} {...{ 'test-id': centsValueTestId }}>
            {price.cents}
          </span>
        </Typography>
      </div>

      {direction === MoneyRendererV3DirectionEnum.ROW && promotionContent}
    </div>
  );
};

export default MoneyRendererV3;
